import { module } from 'modujs';
import { html } from '../utils/environment'


export default class extends module {
    constructor(m) {
        super(m);
        this.events = {
            click: {
                toggler: 'toggleMenu'
            }
        }
    }

    init() {

    }

    toggleMenu() {
        if (!html.classList.contains('has-menu-open')) {
            this.call('toggleMenu', null, 'MenuButton')
        }
        // create invisible dummy input to receive the focus first
        const fakeInput = document.createElement('input')
        fakeInput.setAttribute('type', 'text')
        fakeInput.style.position = 'absolute'
        fakeInput.style.opacity = 0
        fakeInput.style.height = 0
        fakeInput.style.fontSize = "16px" // disable auto zoom

        // you may need to append to another element depending on the browser's auto 
        // zoom/scroll behavior
        document.body.prepend(fakeInput)

        // focus so that subsequent async focus will work
        fakeInput.focus()

        setTimeout(() => {

            // now we can focus on the target input
            document.querySelector('.c-menu-mobile .c-search_input').focus()

            // cleanup
            fakeInput.remove()

        }, 600)
    }
}
